// extracted by mini-css-extract-plugin
export const toggle_wrapper = "themeToggle-module--toggle_wrapper--1i24F";
export const toggle = "themeToggle-module--toggle--3U815";
export const slider = "themeToggle-module--slider--ywQG5";